import { Link, useLocation } from "react-router-dom";

export default function Footer() {
    const loc = useLocation();
    if (loc.pathname.startsWith("/tv") || loc.pathname.startsWith("/admin") || loc.pathname.startsWith("/agent") || loc.pathname.startsWith("/login") || loc.pathname.startsWith("/presentations") || loc.pathname.startsWith("/forgot-password") || loc.pathname.startsWith("/reset-password")) return null;
    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-black mt-24">
            <div className="container-luxury py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="font-serif text-3xl tracking-tight">
                        Tile<span className="text-gold">Sphere</span>
                    </div>
                    <p className="mt-6 max-w-md text-white/60 leading-relaxed text-sm">
                        A curated digital showroom of completed luxury tile installations from a network of premium tile companies.
                        Designed for architects, interior designers, and discerning clients.
                    </p>
                </div>
                <div>
                    <div className="overline mb-5">Explore</div>
                    <ul className="space-y-3 text-white/70 text-sm">
                        <li><Link className="hover:text-gold" to="/explore">All Projects</Link></li>
                        <li><Link className="hover:text-gold" to="/companies">Companies</Link></li>
                        <li><Link className="hover:text-gold" to="/saved">Saved Inspirations</Link></li>
                        <li><Link className="hover:text-gold" to="/tv">Showroom TV Mode</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="overline mb-5">For Partners</div>
                    <ul className="space-y-3 text-white/70 text-sm">
                        <li><Link className="hover:text-gold" to="/login">Agent Portal</Link></li>
                        <li><Link className="hover:text-gold" to="/about">About</Link></li>
                        <li><Link className="hover:text-gold" to="/contact">Contact</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5 py-8">
                <div className="container-luxury flex flex-col md:flex-row justify-between items-center text-xs text-white/40 tracking-[0.2em] uppercase gap-4">
                    <span>© {new Date().getFullYear()} TileSphere. All Rights Reserved.</span>
                    <span>A Premium Virtual Showroom Experience</span>
                </div>
            </div>
        </footer>
    );
}
